import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useState } from "react";
import { Confirm, useMutation, useNotify, useRefresh, useTranslate } from "react-admin";

import { OrderDocumentOutputType } from "../../../entities";

// TODO: move codes color to sahred place
const useStyles = makeStyles((t) => ({
	unloadButton: {
		backgroundColor: "rgba(183,255,125,0.2)",
	},
	loadButton: {
		backgroundColor: "rgba(255,140,140,0.1)",
	},
}));

export const GenerateDocumentsOutputButton = ({
	type,
	isLoading,
	setIsLoading,
	disabled,
	order,
	buttonText,
	margin,
	isOutputDoc,
	onOutDocWarnings,
}) => {
	const [open, setOpen] = useState(false);
	const refresh = useRefresh();
	const notify = useNotify();
	const translate = useTranslate();
	const classes = useStyles();

	const type_name = Object.keys(OrderDocumentOutputType).find(
		(key) => OrderDocumentOutputType[key] === type
	);

	let date = new Date();
	let offset = date.getTimezoneOffset();

	const createOutDoc = async () => {
		await fetch(`/orders/${order.id}/documents-output`, {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				type: type,
				offset: (offset / 60) * -1,
			}),
		})
			.then(async (res) => {
				const data = await res.json();

				if (!res.ok) {
					throw new Error(data?.message || "Unknown error");
				}

				return data;
			})
			.then((data) => {
				notify(translate(`osfc.dialogs.confirm_generate_doc.${type_name}.success`));
				onOutDocWarnings(data.warnings || []);
				handleDialogClose();
				refresh();
			})
			.catch((err) => {
				notify(err.message || "Server error", { type: "error" });
			})
			.finally(() => setIsLoading(false));
	};

	const handleClick = (e) => {
		e.stopPropagation();
		if (isOutputDoc) {
			setOpen(true);
		} else {
			setIsLoading(true);
			createOutDoc();
		}
	};

	const handleDialogClose = () => setOpen(false);
	const handleConfirm = async () => {
		setIsLoading(true);
		createOutDoc();
		setOpen(false);
	};

	return (
		<Box m={margin}>
			{/* <Button variant="contained" className={isOutputDoc ? classes.loadButton : classes.unloadButton} onClick={handleClick} endIcon={type === OrderDocumentOutputType.loading ? <GetAppIcon/> : <PublishIcon/>}>{translate(buttonText)}</Button> */}

			<Button
				variant="contained"
				disabled={disabled}
				className={isOutputDoc ? classes.loadButton : classes.unloadButton}
				onClick={handleClick}
			>
				{translate(buttonText)}
			</Button>
			{isOutputDoc && (
				<Confirm
					isOpen={open}
					loading={isLoading}
					title={`osfc.dialogs.confirm_regenerate_doc.${type_name}.confirm.title`}
					content={`osfc.dialogs.confirm_regenerate_doc.${type_name}.confirm.content`}
					onConfirm={handleConfirm}
					onClose={handleDialogClose}
					confirm="osfc.buttons.confirm"
					confirmColor="warning"
				/>
			)}
		</Box>
	);
};
